import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { DataProvider } from './contexts/DataContext';
import AppRoutes from './routes/AppRoutes';
import LoadingSpinner from './components/common/LoadingSpinner'; // Import the spinner

import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import './styles/App.css'; // Your custom styles (optional)
import './i18n'; // Initialize i18next

function App() {
    return (
        <Suspense fallback={<div className="vh-100 d-flex justify-content-center align-items-center"><LoadingSpinner message="Loading Application..." /></div>}>
            <BrowserRouter>
                <SettingsProvider> {/* Settings first for i18n init */}
                    <AuthProvider>
                        <DataProvider> {/* Data context wraps routes */}
                            <AppRoutes />
                        </DataProvider>
                    </AuthProvider>
                </SettingsProvider>
            </BrowserRouter>
        </Suspense>
    );
}

export default App;